import React from "react";
import i18n from "@microdoing/shared/i18n";
import EmptyLottie from "app/scenes/MessageScreen/EmptyLottie";
import { Box, MainButton, MainText } from "../../../../components/common";
import { useSelector } from "react-redux";
import { getCampaignRequesting } from "@microdoing/shared/services/userCampaign/selectors";

interface IProps {
  onPressRefresh: () => void;
}

const NoCampaign = ({ onPressRefresh }: IProps) => {
  const requesting = useSelector(getCampaignRequesting);

  return (
    <Box
      variant="screenView"
      width="100%"
      flex={1}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      marginTop="m"
    >
      {!requesting && (
        <MainText textAlign="center">{i18n.t("no-current-campaign")}</MainText>
      )}
      <EmptyLottie />
      <MainButton
        isLoading={requesting}
        marginTop="m"
        text={i18n.t("refresh")}
        onPress={onPressRefresh}
      />
    </Box>
  );
};

export default NoCampaign;
